import { useState } from 'react';
import styled from '@emotion/styled';

import { Button, TextField } from '@mui/material';

import Dialog from '../../../utils/utilities/Dialog';

import { BasicFlex } from '../../../utils/Common';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { topUpStock } from '../apiService';

import useSnackbarStore from '../../../store/snackbar';

const Container = styled.div`
  padding: 1.6rem;
`

const AddStock = ({ open, setOpen, product_id, setProductId }) => {

  const [stock, setStock] = useState("");

  const queryClient = useQueryClient();

  const showSnackbar = useSnackbarStore((state) => state.showSnackbar);

  const { mutate } = useMutation({
    mutationFn: () => topUpStock(product_id, stock),
    onSuccess: () => {
      showSnackbar('Added successfully!', 'success');
      queryClient.invalidateQueries(['products']);
      handleClose();
    },
    onError: (error) => {
      showSnackbar('Failed to add!', 'error');
      console.log(error);
    }
  })

  const handleClose = () => {
    setOpen(false);
    setStock("");
    setProductId(null);
  }

  return (
    <Dialog
      title="Add Stock Quantity"
      size="md"
      forceOpen={open}
      forceClose={handleClose}
      saveFunc={() => {
        mutate();
      }}
      saveText="Add Stock"
    >
      <Container>
        <TextField
        autoFocus={true}
          name="stock"
          label="Add Stock Quantity"
          type="number"
          value={stock}
          onChange={(e) => setStock(e.target.value)}
          fullWidth
        />
      </Container>
    </Dialog>
  )
  
};

export default AddStock;